import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import defaultImage from "@/assets/images/logo_dg.png";
import styles from "./GameCard.module.css";

interface Props {
  title: string;
  description: string;
  image: string;
  slug: string;
}

export const GameCard: FunctionComponent<Props> = ({
  title,
  description,
  image,
  slug,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.imageContainer}>
        <img
          src={image || defaultImage}
          alt={title}
          className={styles.image}
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.src = defaultImage;
          }}
        />
        <div className={styles.gradient} />
        {!image && (
          <div className={styles.placeholder}>
            <div className={styles.placeholderIcon}>🎮</div>
          </div>
        )}
      </div>

      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>

        <Link to={`/game-info/${slug}`} className={styles.button}>
          Подробнее
        </Link>
      </div>
    </div>
  );
};
